<template>
	<div class="pfbg"></div>
	<div class="pf_ai">
		<em class="iconfont icon-htmal5icon19" @click="btnClick('close')"></em>
		<div class="ai_head">
			<div class="a d-flex a-center j-center">
				<img src="@/assets/images/ind_ai.png" class="ai" />
				我是 DeepSeek，很高兴见到你！
			</div>
			<div class="b">我可以帮您解答农业相关的问题或者了解农业相关的政策和资讯，请把你的任务交给我吧~</div>
		</div>
		<div class="ai_con" id="aiBox">
			<template v-for="(item,index) in aiLogs">
				<div class="fa d-flex j-end" v-if="item.fa_type == 1">
					<div class="wz">{{item.content}}</div>
				</div>

				<div class="da d-flex" v-else>
					<div class="wz" v-html="item.content"></div>
				</div>
			</template>

			<div class="load font-16 d-flex a-center" v-if="loadShow">
				AI思考中
				<div class="loadding-box">
					<div class="dot1"></div>
					<div class="dot2"></div>
					<div class="dot3"></div>
				</div>
			</div>
		</div>
		<div class="ai_bd d-flex a-center">
			<div class="inp">
				<input type="text" v-model="contents" placeholder="有问题，尽管问" />
			</div>
			<div class="btn" @click="sendAi">发送</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'index',
		data() {
			return {
				contents: '',
				aiLogs: [],
			}
		},
		mounted() {

		},
		methods: {

			btnClick(e, item = '') {
				var that = this
				if (e == 'close') {
					this.$emit('aiClick', {
						sta: 'close'
					})
				}
			},
			sendAi() {
				var that = this;
				if (!that.contents) {
					that.$toast('请输入您要咨询的问题');
					return
				}
				if (that.loadShow) {
					that.$toast('请回答完毕再咨询下一个问题');
					return
				}

				const contents = that.contents

				that.aiLogs.push({
					fa_type: 1,
					content: contents
				})
				that.loadShow = true
				that.contents = ''
				var element = document.getElementById("aiBox");
				setTimeout(function() {
					element.scrollTop = element.scrollHeight;
				}, 100)

				that.$axios.post(that.$baseUrl.nyaiApi, {
						contents: contents
					})
					.then(res => {
						if (res.code == 200) {
							var contents2 = res.data.text
							contents2 = contents2.replace(/\n/g, '<br />');
							that.aiLogs.push({
								fa_type: 2,
								content: contents2
							})
							that.loadShow = false

							setTimeout(function() {
								element.scrollTop = element.scrollHeight;
							}, 500)

						} else {
							that.$toast(res.msg);
						}
					})
					.catch(error => {
						console.error(error)
					})
			},

		}
	}
</script>

<style lang="less">
	.pf_ai {
		position: fixed;
		left: 50%;
		top: 50%;
		background-color: #fff;
		border-radius: 10px;
		width: 800px;
		z-index: 101;
		transform: translate(-50%, -50%);
		box-sizing: 20px;
		box-sizing: border-box;
		display: flex;
		flex-direction: column;

		.icon-htmal5icon19 {
			position: absolute;
			right: -30px;
			top: -30px;
			font-size: 38px;
			line-height: 1;
			cursor: pointer;
			color: #ffffff;
		}

		.ai_head {
			padding: 20px;

			.a {
				img {
					display: block;
					width: 50px;
					height: 50px;
					margin-right: 20px;
				}

				font-size: 24px;
				font-weight: bold;
			}

			.b {
				font-size: 16px;
				color: #999;
				text-align: center;
				padding-top: 10px;
			}
		}

		.ai_con {
			margin: 10px;
			padding: 10px;
			overflow: hidden;
			overflow-y: auto;
			height: 50vh;

			.fa {
				padding-left: 200px;
				margin-bottom: 20px;

				.wz {
					background-color: #f1f1f1;
					padding: 10px 20px;
					border-radius: 14px 0 14px 14px;
				}
			}

			.da {
				padding-right: 200px;
				margin-bottom: 20px;

				.wz {
					background-color: #f4f5f6;
					padding: 10px 20px;
					border-radius: 0 14px 14px 14px;
				}
			}
		}

		.ai_bd {
			background-color: #f4f5f6;
			padding: 15px;
			border-radius: 0 0 10px 10px;

			.inp {
				flex: 1;
				margin-right: 20px;

				input {
					text-indent: 1em;
					font-size: 18px;
					color: #282828;
					width: 100%;
					height: 48px;
					line-height: 48px;
					border: #d1d1d1 solid 1px;
					border-radius: 5px;
				}
			}

			.btn {
				background: #55AA44;
				width: 100px;
				height: 50px;
				border-radius: 5px;
				color: #fff;
				text-align: center;
				line-height: 50px;
				font-size: 18px;
			}
		}
	}

	.loadding-box {
		display: flex;

		.dot1,
		.dot2,
		.dot3 {
			width: 6px;
			height: 6px;
			border-radius: 50%;
			margin-left: 6px;
		}

		.dot1 {
			animation: jump 1.2s -0.4s linear infinite;
			background: #8c8ef7;
		}

		.dot2 {
			animation: jump 1.2s -0.2s linear infinite;
			background: #5e85d1;
		}

		.dot3 {
			animation: jump 1.2s linear infinite;
			background: #2e6de7;
		}

		@keyframes jump {

			0%,
			80%,
			100% {
				transform: scale(0.8);
				opacity: 1.0;
			}

			40% {
				transform: scale(1.1);
				opacity: 0.8;
			}
		}
	}
</style>